<div class="title-icon" [ngClass]="size">
    <img class="icon" [src]="iconSrc" alt="Icon">
    <span class="title" [ngClass]="size">{{ title }}</span>
</div>